module.exports = __webpack_public_path__ + "static/media/Fs7v6.4869d402.mp3";